import React, {useEffect, useState} from "react";
import {getCourierBusinessId, getUserPhoneNumber} from "../../helpers/authenticator";
import models from "../../network/models/quick_models";
import general_helper, {googleMapsExternalLink} from "../../helpers/general_helper";
import DeliveryItem from "../../components/dashboard/DeliveryItem";
import DeliveryMetaCard from "../../components/MetaCard";
import rider from "../../network/services/rider";
import toastifyHelper from "../../helpers/toastify_helper";
import Loader from "react-loaders";
import DeliveryConfirmationModal from "../../components/dashboard/DeliveryConfirmationModal";
import DeliverySuccessReceipt from "../../components/DeliverySuccessReceipt";


const RequestDetails = () => {
    let id = window.location.pathname.replace("/requests/", "");
    const [delivery, setDelivery] = useState({});
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        fetchDeliveryData();
    }, []);

    const fetchDeliveryData = () => {
        rider.getRiderSingleDelivery(getUserPhoneNumber(), id).then(response => {
            setDelivery(response.data.data);
            setIsLoading(false);
        }).catch(error => {
            console.log("error", error.response.data.message);
            setIsLoading(false);
            toastifyHelper.toastify.errorToastify(error.response.data.message);
        })
    };

    let deliveryItem = {...models.createDeliveryOrderResponse, ...delivery};
    let origin = deliveryItem.pick_up.latitude + "," + deliveryItem.pick_up.longitude;
    let destination = deliveryItem.drop_off.latitude + "," + deliveryItem.drop_off.longitude;


    const handleButtonClicked = () => {
        let data = models.riderUpdateDeliveryStatusRequest;
        data.agent_id = getUserPhoneNumber();
        data.business_id = getCourierBusinessId();
        data.delivery_id = id;
        data.status = general_helper.getNextStatus(deliveryItem.status);
        data.tracking_id = deliveryItem.tracking_id;

        rider.riderUpdateDeliveryStatus(getUserPhoneNumber(), deliveryItem.delivery_id, data).then(response => {
            //Update view with the latest data
            toastifyHelper.toastify.successToastify(response.data.message);
            fetchDeliveryData();
        }).catch(error => {
            toastifyHelper.toastify.errorToastify(error.response.data.message);
        })
    };

    return (
        <div className="mainWrapper" style={{marginTop: 150}}>
            <div className="container">
                <div className="row justify-content-center" style={{marginLeft: 45, marginRight: 45}}>
                    {isLoading ? <Loader type="ball-scale-multiple"/> :
                        deliveryItem.complete === "1" ?
                            <DeliverySuccessReceipt deliveryItem={{data: deliveryItem}}/> :
                            <div className="col-md-5">
                                <div className="row no-gutters">
                                    <div className="col-6 text-left">
                                        <p className="small-text-grey">Tracking ID</p>
                                        <h6>
                                            {deliveryItem.tracking_id}
                                        </h6>
                                    </div>
                                    <div className="col-6 text-right">
                                        <a target="_blank" href={googleMapsExternalLink(origin, destination)}
                                           className="small-text-blue">View
                                            on Maps >></a>
                                        <p className="small-text-grey">It will take
                                            about {deliveryItem.quote.duration} {deliveryItem.quote.duration_unit}</p>
                                    </div>
                                </div>
                                <DeliveryItem style={{marginTop: 5}}
                                              delivery={{item: deliveryItem, index: 0, showCTA: false}}/>
                                <br/>
                                <br/>
                                <br/>
                                <small>Pick Up Location details</small>
                                <DeliveryMetaCard
                                    data={{
                                        title: deliveryItem.pick_up.name,
                                        subTitle: deliveryItem.pick_up.phone_number
                                    }}/>
                                <small>Drop-off Location details</small>
                                <DeliveryMetaCard
                                    data={{
                                        title: deliveryItem.drop_off.address,
                                        subTitle: deliveryItem.drop_off.phone_number
                                    }}/>
                                {
                                    deliveryItem.status === "drop_off" ?
                                        <button disabled={deliveryItem.status === "delivered"}
                                                data-toggle="modal"
                                                data-target="#confirmationModal"
                                                className="btn btn-primary btn-md btn-block">
                                            {general_helper.displayNextDeliveryStatus(deliveryItem.status)}
                                        </button> :
                                        <button disabled={deliveryItem.status === "delivered"}
                                                onClick={() => handleButtonClicked()}
                                                className="btn btn-primary btn-md btn-block">
                                            {general_helper.displayNextDeliveryStatus(deliveryItem.status)}
                                        </button>
                                }
                                <small className="text-center">Cancel</small>
                            </div>
                    }
                </div>
            </div>
            <DeliveryConfirmationModal deliveryItem={{item: deliveryItem}}/>
        </div>
    );
};

export default RequestDetails;
